import React, { useEffect, useState } from 'react'
import { Accolade } from '../../../../Api/Teams/team.types'
import { returnAccoladeCount } from '../../../../Utils/Players/playersHelper'
import { AccoladeStyle } from './styles'

type AccoladeProps = {
  accolade: Accolade
  teamColor?: string
}

export const AccoladeItem: React.FC<React.PropsWithChildren<AccoladeProps>> = ({
  accolade,
  teamColor,
}) => {
  const [yrs, setYrs] = useState<number[]>([])

  useEffect(() => {
    if (accolade.years && accolade.years.length > 0) {
      const sorted = accolade.years.sort((a, b) => a - b)
      setYrs(sorted)
    }
  }, [])
  return (
    <AccoladeStyle>
      <div className="accoladeCol">
        <div className="name">{accolade.awardName}</div>
        <div className="yearCon">
          {yrs.length > 0 &&
            accolade.years.map((yr, idx) => (
              <div className="years" key={yr}>
                {idx + 1 === accolade.years.length ? ` ${yr}` : ` ${yr},`}
              </div>
            ))}
        </div>
      </div>
      <div className="accoladeCount">{returnAccoladeCount(accolade)}X</div>
    </AccoladeStyle>
  )
}
